import * as z from "zod";

export const getWarehouseFlowGradeStatus = {
  name: "getWarehouseFlowGradeStatus" as const,
  input: z.object({ gradeNames: z.array(z.string()) }),
  output: z.object({
    needsUpdate: z.boolean(),
    orphanedGrades: z.array(z.string()),
  }),
};
